import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import ShopmyImage from '../General/ShopmyImage';
import { getPrettyPriceDisplay } from '../../helpers/formatting';
import './NewProductTile.scss';

const NewProductTile = ({ product, onToggleHidden }) => {
  const priceDisplay = Number(product.price) ? getPrettyPriceDisplay(product.price, { precision: 0 }) : null;
  const rateDisplay = product.rateDisplay || null;
  const openProduct = () => {
    if (product.url) window.open(product.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={cn('new-product-admin-tile', { hidden: product.isHidden })}>
      <div className='product-image-container' onClick={openProduct}>
        {product.image ? (
          <ShopmyImage source={product.image} alt={product.title} className='product-image' />
        ) : (
          <div className='product-image empty' />
        )}
        {!!rateDisplay && <div className='commission-chip'>{rateDisplay}</div>}
        <button
          type='button'
          className='visibility-btn'
          title={product.isHidden ? 'Show product' : 'Hide product'}
          onClick={e => {
            e.stopPropagation();
            onToggleHidden();
          }}
        >
          <FontAwesomeIcon icon={product.isHidden ? faEyeSlash : faEye} />
        </button>
      </div>
      {!!product.brandName && <div className='product-brand'>{product.brandName}</div>}
      <div className={cn('product-title', { clickable: !!product.url })} onClick={openProduct}>
        {product.title || 'Untitled'}
      </div>
      {!!priceDisplay && <div className='product-price'>{priceDisplay}</div>}
      {product.isHidden && <div className='product-hidden-reason'>{product.hiddenReasonLabel || 'Hidden'}</div>}
    </div>
  );
};

NewProductTile.propTypes = {
  product: PropTypes.object.isRequired,
  onToggleHidden: PropTypes.func.isRequired
};

export default NewProductTile;
